// extracted by mini-css-extract-plugin
export default {"stats_per_branch":"StatisticsPerBranch_stats_per_branch__NyGhj"};